<script lang="ts">
	//Formating
	import { format } from 'svelte-i18n';
	//Design system components
	import { Text, Select, Input, Slider, TemperatureWheel } from '@Shelly/shelly-design-system';
	//Helpers
	import { getStatusIconByRole } from 'src/helpers/xt1_helpers/template_helpers';
	import { getNumberInputConfig } from 'src/helpers/number_input_helpers';
	import { getErrorOrInfoMessageForMinAndMaxUnit } from 'src/helpers/utilities';
	//Types
	import type { LocalControlOptions } from 'src/types/requests/schedules/schedules_g2';

	export let controlOption: LocalControlOptions['virtual'];

	let virtualControlOption: LocalControlOptions = controlOption.selected;
	$: unit = virtualControlOption?.unit || '';
	$: min = virtualControlOption?.config?.min ?? 0;
	$: max = virtualControlOption?.config?.max ?? 100;
	$: step = virtualControlOption?.config?.meta?.ui?.step || 1;

	const a11yPropsSliderPos = {
		sliderValueText: $format('current_value', {
			values: { value: virtualControlOption?.params?.value || 0 },
			default: `Current value is ${virtualControlOption?.params?.value || 0}`,
		}),
		ariaLabel: $format('label_set_value', { default: 'Set Value' }),
		ariaLabelValue: $format('current_value', {
			values: { value: virtualControlOption?.params?.value || 0 },
			default: `Current value is ${virtualControlOption?.params?.value || 0}`,
		}),
	};

	const a11yProps = {
		tempWheelAriaLabel: $format('label_temperature', {
			default: 'Temperature',
		}),
		thumbAriaLabel: $format('label_temperature_thumb', {
			default: 'Temperature thumb',
		}),
		incrementBtnAriaLabel: $format('button_increase_temperature', {
			default: 'Increase temperature',
		}),
		decrementBtnAriaLabel: $format('button_decrease_temperature', {
			default: 'Decrease temperature',
		}),
	};
</script>

<div>
	<Text class="mb-s" element="h2">
		{$format('schedule_select_local_action', {
			default: 'Select Local Action',
		})}:
	</Text>
	<Select
		size="m"
		value={virtualControlOption}
		options={controlOption.options}
		icon="fa fa-list"
		on:change={(e) => {
			//@ts-ignore
			virtualControlOption = e.detail;
			controlOption.selected = virtualControlOption;
		}}
		id="select-rmnmxd5"
		aria-label={$format('schedule_select_local_action', {
			default: 'Select Local Action',
		})}
	/>
</div>

<div>
	{#if !virtualControlOption?.enums || virtualControlOption.enums?.length > 1}
		<Text class="mb-s" element="h2">
			{$format('action_change_value', {
				default: 'Action value',
			})}:
		</Text>
	{/if}
	{#if virtualControlOption?.enums}
		{#if virtualControlOption.enums?.length > 1}
			<Select
				size="m"
				value={virtualControlOption.enums.find(
					(i) =>
						i.value ==
						(/^(button)/.test(virtualControlOption.value)
							? virtualControlOption.params.event
							: virtualControlOption.params.value),
				) || virtualControlOption.enums[0]}
				options={virtualControlOption.enums}
				icon={virtualControlOption.icon || 'fa fa-pen'}
				tabIndex="-1"
				on:change={(e) => {
					if (/^(button)/.test(virtualControlOption.value)) {
						virtualControlOption.params.event = e.detail['value'];
					} else {
						virtualControlOption.params.value = e.detail['value'];
					}
				}}
				id="select-yfr22ju"
				aria-label={$format('action_change_value', {
					default: 'Action value',
				})}
			/>
		{/if}
	{:else if /(temperature|humidity)/.test(virtualControlOption?.role)}
		<TemperatureWheel
			{a11yProps}
			class="mb-s"
			valuePrefix={unit}
			icon={getStatusIconByRole(virtualControlOption.role)}
			value={virtualControlOption.params.value}
			{min}
			{max}
			type={/humidity/.test(virtualControlOption?.role) ? 'humidity' : 'temp'}
			{step}
			btnStep={step}
			on:value_change={(event) => {
				virtualControlOption.params.value = event.detail.value;
			}}
		/>
	{:else if virtualControlOption?.config?.meta?.ui?.view == 'slider'}
		<Slider
			id="slider-zv3fas1"
			type="simple"
			value={virtualControlOption.params.value}
			{step}
			{unit}
			{min}
			{max}
			on:value_change={(e) => {
				virtualControlOption.params.value = e.detail.value;
			}}
			a11yProps={a11yPropsSliderPos}
			title={$format('label_cover_slider_title_min_max_unit', {
				values: { pos: virtualControlOption.params.value, min, max, unit },
				default: 'Selected: {pos}{unit}, Range: ( {min}{unit} - {max}{unit} )',
			})}
		/>
	{:else if virtualControlOption?.params}
		{@const minMaxInfo = /^(number)/.test(virtualControlOption.value)
			? getErrorOrInfoMessageForMinAndMaxUnit(virtualControlOption.params.value, min, max, unit)
			: { info: '', error: '' }}
		<Input
			size="m"
			value={virtualControlOption.params.value}
			label={$format('action_change_value', {
				default: 'Action value',
			})}
			{.../^number/.test(virtualControlOption.value) ? { ...getNumberInputConfig() } : {}}
			icon={virtualControlOption.icon ||
				(/^(number)/.test(virtualControlOption.value) ? 'fa fa-calculator' : 'fa fa-pen')}
			tabIndex="-1"
			on:input={(e) => {
				virtualControlOption.params.value = e.target['value'];
			}}
			info={minMaxInfo.info}
			error={minMaxInfo.error}
			id="input-cor27kf"
			aria-labelledby="input-cor27kf"
		/>
	{/if}
</div>
